// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1rWRw","link":"Footer_link__2HEF7","copyright":"Footer_copyright__2ndf-"};